import ReactTooltip from "react-tooltip";

// MU
import { Grid } from "@material-ui/core";

// Contextos
import { useApp } from "../../../contexts/app";

// Estilos
import { useStyles } from "./styles";
import { paletas } from "../../../styles/theme";

// Componentes
import Botao from "../../../componentes/botao";

type Props = {
  iniciarTreino: () => void;
  procurarBatalha: () => void;
  procurarTorneio: () => void;
};

export default function Controles({
  iniciarTreino,
  procurarBatalha,
  procurarTorneio,
}: Props) {
  const { usuario, statusBatalhando } = useApp();
  const classes = useStyles();
  const habilitaBatalha = usuario?.player_statistics?.experience < 200;
  const semLiga = usuario?.player_statistics?.league === "";
  const isOnline = navigator.onLine;

  return (
    <Grid
      container
      spacing={2}
      className={`${classes.root} ${statusBatalhando ? "oculta" : "exibe"}`}
    >
      <Grid item xs={4}>
        <Botao
          type="button"
          value="TREINAR"
          color={paletas.Grafite}
          background={paletas.DarkOrange}
          border={paletas.DarkOrange}
          size="20px"
          onClick={iniciarTreino}
          disabled={statusBatalhando}
        />
      </Grid>
      <Grid
        item
        xs={4}
        data-tip
        data-for={habilitaBatalha ? "batalha" : ""}
        data-iscapture="true"
      >
        <Botao
          type="button"
          value="BATALHAR"
          color={paletas.Grafite}
          background={paletas.DarkOrange}
          border={paletas.DarkOrange}
          size="20px"
          onClick={procurarBatalha}
          disabled={
            (statusBatalhando || habilitaBatalha || !usuario.email) && isOnline
          }
        />
      </Grid>
      <Grid
        item
        xs={4}
        data-tip
        data-for={semLiga ? "torneio" : ""}
        data-iscapture="true"
      >
        <Botao
          type="button"
          value="TORNEIOS"
          color={paletas.Grafite}
          background={paletas.DarkOrange}
          border={paletas.DarkOrange}
          size="20px"
          onClick={procurarTorneio}
          disabled={(statusBatalhando || semLiga || !usuario.email) && isOnline}
        />
      </Grid>
      <ReactTooltip id="batalha" type="dark" place="top">
        Atinja o level 3!
      </ReactTooltip>
      <ReactTooltip id="torneio" type="dark" place="top">
        Conquiste uma liga para participar de torneios!
      </ReactTooltip>
    </Grid>
  );
}
